import PolicyNote from './PolicyNote';
import { UnderwriterActionType } from '@app/enumerations';

export default class PolicyNoteRecord extends PolicyNote {
	public id: number | null = null;
	public dateSubmit: Date | null = null;
	public submittedBy: string | null = null;
	public isMailed: boolean | null = null;
	public docName: string | null = null;
	public underwriterAction: UnderwriterActionType | null = null;

	public constructor() {
		super();
	}
};